import { Component, OnInit } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';

@Component({
  selector: 'app-new-store',
  templateUrl: './new-store.component.html',
  styleUrls: ['./new-store.component.css']
})
export class NewStoreComponent implements OnInit {

  store = {
    name: '',
    email: '',
    password: '',
    phone: '',
  }

  constructor() { }

  ngOnInit() { }

  signUp() {
    
    if (this.store.name.length < 3 || this.store.email.length < 6 || this.store.password.length < 6 || this.store.phone.length > 11 || this.store.phone.length < 8) {
      alert('Preencha os dados corretamente.');
      return;
    }

    firebase.auth().createUserWithEmailAndPassword(this.store.email, this.store.password).then((r: any) => {
      firebase.firestore().collection('store').doc(r.user.uid).set({
        name: this.store.name,
        email: this.store.email,
        phone: this.store.phone,
        active: false
      }).then(() => {
        alert('Conta de estabelecimento criada com sucesso!');
      });
    }).catch(e => {
      alert(e);
    })
    
  }

}
